import { useAppSelector } from '../setup/hooks';
import { getLocale } from './langSlice';

export const useLocale = () => useAppSelector(getLocale);
